import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Replay from '@material-ui/icons/Reply';

function AvatarCounter(props) {
  return (
    <Avatar className="mui-avatar count-user e-zindex--9">
      +{props.number}
    </Avatar>
  );
}

export default AvatarCounter;
